import type { GCColor } from '@components/atoms/gccolors';

export const IconSizes = {
    // consult with design before adding new sizes
    xxlarge: 115,
    xlarge: 96,
    large: 48,
    medium: 32,
    small: 24,
    xsmall: 16,
    xxsmall: 12,
};

export type IconSize = keyof typeof IconSizes;

export interface IconProps {
    fill?: GCColor;
    stroke?: GCColor;
    size?: IconSize;
    width?: number;
    height?: number;
    className?: string;
}
